import { render, staticRenderFns } from "./CyclesDisciplinesTutors.vue?vue&type=template&id=6cc6249b&scoped=true"
import script from "./CyclesDisciplinesTutors.vue?vue&type=script&lang=js"
export * from "./CyclesDisciplinesTutors.vue?vue&type=script&lang=js"
import style0 from "./CyclesDisciplinesTutors.vue?vue&type=style&index=0&id=6cc6249b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6249b",
  null
  
)

export default component.exports